/*eslint-disable*/
const properties = {
    height: '3.125rem',
    borderRadius: '0.118rem',
    borderWidth: '0.063rem'
  };
  export default properties;